export default __webpack_public_path__ + "static/insect-based-dog-food-1-8fc9677e3cd7d3874a14bf7fe759123e.jpg";